import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import Classes from '../common/Classes';
import ExhibitorImage from '../common/exhibitingOrganisation/ExhibitorImage';
import { Devices, ScreenSizes } from '../common/Constants';


const ExhibitorDirectoryImage = ({
  src, alt, tag, dtmtags, isRounded, defaultLogoUrl
}) => (
  <div className={Classes.exhibitorDirectoryImageContainer}>
    <MediaQuery minWidth={1199}>
      <ExhibitorImage
        src={src}
        deviceType={Devices.desktop}
        imageSize={ScreenSizes.large}
        alt={alt}
        tag={tag}
        dtmtags={dtmtags}
        isRounded={isRounded}
        defaultLogoUrl={defaultLogoUrl}
      />
    </MediaQuery>
    <MediaQuery minWidth={992} maxWidth={1198}>
      <ExhibitorImage
        src={src}
        deviceType={Devices.desktop}
        imageSize={ScreenSizes.small}
        alt={alt}
        tag={tag}
        dtmtags={dtmtags}
        isRounded={isRounded}
        defaultLogoUrl={defaultLogoUrl}
      />
    </MediaQuery>
    <MediaQuery minWidth={768} maxWidth={991}>
      <ExhibitorImage
        src={src}
        deviceType={Devices.mobile}
        imageSize={ScreenSizes.large}
        alt={alt}
        tag={tag}
        dtmtags={dtmtags}
        isRounded={isRounded}
        defaultLogoUrl={defaultLogoUrl}
      />
    </MediaQuery>
    <MediaQuery maxWidth={767}>
      <ExhibitorImage
        src={src}
        deviceType={Devices.mobile}
        imageSize={ScreenSizes.small}
        alt={alt}
        tag={tag}
        dtmtags={dtmtags}
        isRounded={isRounded}
        defaultLogoUrl={defaultLogoUrl}
      />
    </MediaQuery>
  </div>
);


ExhibitorDirectoryImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  tag: PropTypes.string,
  dtmtags: PropTypes.string,
  isRounded: PropTypes.bool,
  defaultLogoUrl: PropTypes.string.isRequired
};

export default ExhibitorDirectoryImage;
